<template>
    <AppModals
        name="account-rename"
        title="Переименовать ЛС / Договор"
		cancelButtonText="Закрыть"
		@beforeOpen="beforeOpen"
        confirmButtonText="Переименовать "
        @confirm="renameAccount"
        :disabledConfirm="!$v.value.required || !$v.value.maxLength"
        :loadingConfirm="loading"
    >
        <template  #content="{}">
            <div class="modal-content">
                <div>
                    <AppInput 
                        placeholder="Введите новое название"
                        v-model.trim="$v.value.$model"
                        :error="$v.value.$error"
                        required
                        maxLength
                        :maxLengthError="$v.value.maxLength"
                        :requiredError="$v.value.required"
                        label="Наименование"
                    >
                        <template slot="required">Заполните это поле</template>
                        <template slot="maxLength">Не более 30 символов</template>
                    </AppInput>

                    <div style="margin: 20px 0">Придумайте своё название для лицевого счета или договора, чтобы быстрее найти его в списке.</div>
                </div>
			</div>
        </template>
    </AppModals>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
	data () {
		return {
            loading: false,
            value: '',
            accountId: null,
            name: ''
		}
	},
	props: {
	/* 	getAccountDetails: {
			type: Object,
			default: {
                balanceType: ''
            }
        }, */
        

    },
    
    mounted() {
        
    },

	methods: {
		modalClose () {
			this.$modal.hide('account-rename')
        },
        
		async renameAccount () {

            this.$v.$touch()

            //if(!this.$v.$invalid) {
                this.loading = true    

                let formData = {
                    accountId: this.accountId,
                    Description: this.value
                }

                try {
                    await this.$store.dispatch('accountRename', formData)
                    this.$modal.hide('account-rename')
                } catch (e) {
                    this.$errorsMod(e.response)
                }

                this.loading = false
            //}
        },

        async beforeOpen (event) {
            this.value = event.type
            this.accountId = event.id
		}
    },
    validations: {
		value: {
			required,
			maxLength: maxLength(30)
		},
	},
}
</script>


<style scoped>

</style>